document.addEventListener('DOMContentLoaded', function() {
    
    const customCloseButton = document.getElementById('custom-gorgias-close-button');

    function handleButtonClick() {
        const iframe = document.getElementById('chat-button');
        if (!iframe) return;
        
        try {
            const iframeContent = iframe.contentWindow.document;
            const buttonInsideIframe = iframeContent.querySelector('button[data-testid]');
            if (buttonInsideIframe) {
                buttonInsideIframe.click();
            }
        } catch (e) {
            console.error('Gorgias chat button could not be triggered.', e);
        }
    }

    // Menggunakan event delegation pada body untuk menangani klik
    document.body.addEventListener('click', function(event) {
        const link = event.target.closest("a[href='#live-chat']");
        if (link) {
            event.preventDefault();
            handleButtonClick();
        }
    });

    if (customCloseButton) {
        customCloseButton.addEventListener('click', function(event) {
            event.preventDefault();
            handleButtonClick();
        });
    }

    function initializeGorgiasObserver(chatContainer) {
        if (!customCloseButton) return;

        const mainObserver = new MutationObserver(function(mutations) {
            const chatWindow = document.getElementById('chat-window');
            
            if (chatWindow) {
                const styles = window.getComputedStyle(chatWindow);
                const isChatWindowVisible = styles.visibility !== 'hidden' && styles.display !== 'none' && parseInt(styles.height, 10) > 50;
                
                // -- PERUBAHAN UTAMA: Toggle class .is-visible --
                if (isChatWindowVisible) {
                    customCloseButton.classList.add('is-visible');
                } else {
                    customCloseButton.classList.remove('is-visible');
                }
            } else {
                customCloseButton.classList.remove('is-visible');
            }
        });

        mainObserver.observe(chatContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });
    }

    const finderObserver = new MutationObserver(function(mutations, me) {
        const chatContainer = document.getElementById('gorgias-chat-container');
        if (chatContainer) {
            initializeGorgiasObserver(chatContainer);
            me.disconnect();
        }
    });

    finderObserver.observe(document.body, {
        childList: true,
        subtree: true 
    });
});